import { render } from "./underwriter.configuration.vue?vue&type=template&id=461112e7"
import script from "./underwriter.configuration.vue?vue&type=script&lang=js"
export * from "./underwriter.configuration.vue?vue&type=script&lang=js"

import "./underwriter.configuration.vue?vue&type=style&index=0&id=461112e7&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__